/**
 * Получение необходимых агрументов для эмбед-скрипта
 * @param {String} str строка с «сырым» кодом на вставку
 * @return {Object} {{}} объект с необходимыми параметрами
 */
export function findEmbedArg(str) {
    str = str.replace(/\)/g, '').replace(/\n/g, '').replace(/"/g, '');
    const arr = str.split('(');
    let obj = {};
    for (let i = 0, max = arr.length; i < max; i += 1) {
        if (arr[i].search('vk_post') === 0) {
            arr[i] = arr[i].replace(/ setTimeout/g, '');
            const newArr = arr[i].split(',');
            obj = {
                element_id: newArr[0],
                owner_id: parseInt(newArr[1], 10),
                post_id: parseInt(newArr[2], 10),
                hash: newArr[3].replace(/ /g, '').replace(/'/g, '')
            };
        }
    }
    return obj;
}

export default function vkEmbedScript(data) {
    const args = findEmbedArg(data);
    return (`
        <div id=${args.element_id}></div>
        <script type="text/javascript">
            (function() {
                const vkWrapper = document.getElementById('${args.element_id}');
                if (vkWrapper.children.length) {
                    return;
                }
                (function(d, s, id) {
                    var js, fjs = d.getElementsByTagName(s)[0];
                    if (d.getElementById(id)) return;
                    js = d.createElement(s);
                    js.id = id;
                    js.src = "https://vk.com/js/api/openapi.js?149";
                    fjs.parentNode.insertBefore(js, fjs);
                }(document, 'script', 'vk_openapi_js'));

                function renderVkEmbed() {
                    if (vkWrapper.children.length) {
                        return;
                    }
                    console.log(Date.now());
                    window.VK && VK.Widgets
                    && VK.Widgets.Post
                    && VK.Widgets.Post("${args.element_id}", ${args.owner_id}, ${args.post_id}, '${args.hash}', {width: 500})
                    || setTimeout(() => {
                        renderVkEmbed();
                    }, 500);
                }
                renderVkEmbed();
            }());
        </script>
    `);
}


// WEBPACK FOOTER //
// src/components/editor/vkEmbed.js